import React from "react";
import { encryptId } from "../../../../core/utils/crypto";
import { showToast } from "../../../../core/utils/alert";

interface ShareLinkModalProps {
  show: boolean;
  onClose: () => void;
  newStudentId: string | null;
}

const ShareLinkModal: React.FC<ShareLinkModalProps> = ({ show, onClose, newStudentId }) => {
  if (!show || !newStudentId) return null;

  const handleCopy = () => {
    const url = `${window.location.origin}/complete-registration/${encryptId(newStudentId)}`;
    navigator.clipboard.writeText(url);
    showToast({ text: "Link copied to clipboard!", icon: "success" });
  };

  const handleShare = () => {
    const url = `${window.location.origin}/complete-registration/${encryptId(newStudentId)}`;
    const text = encodeURIComponent(`Please click the link to complete your student registration:\n\n${url}`);
    window.open(`https://wa.me/?text=${text}`, '_blank');
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal fade show d-block" tabIndex={-1} style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Share Registration Link</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <p>Student registered successfully. Please share this link with the student or parents to complete their registration:</p>
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  value={`${window.location.origin}/complete-registration/${encryptId(newStudentId)}`}
                  readOnly
                />
                <button className="btn btn-outline-primary" type="button" onClick={handleCopy}>
                  <i className="ti ti-copy"></i> Copy
                </button>
                <button className="btn btn-outline-success" type="button" onClick={handleShare}>
                  <i className="ti ti-brand-whatsapp"></i> Share
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" onClick={onClose}>
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareLinkModal;
